(function(angular){
    'use strict';
    const app = angular.module('enervee');
    
    app.factory('ForgotPasswordService', [
        'UserApiConsumerService',
        function(UserApiConsumerService) {
            let _passwordResetSent = null;
            const _pub = {
                resetPassword: resetPassword,
                resetPasswordSent: resetPasswordSent
            };

            return _pub;
            /**
             * Resets existing user's account. Sends and email to reset password.
             * @param {string} email - existing user's email.
             * @param {string} nextUrl - Optional url to redirect user after login.
             * @returns {*}
             */
            function resetPassword(email, nextUrl) {
                const URL = 'api/1.0/rest-auth/password/reset/';
                const options = {
                    method: 'POST',
                    url: URL,
                    data: {
                        'email': email,
                        'next_url': nextUrl || null
                    }
                };
                const withCredentials = false;

                return UserApiConsumerService.request(options, withCredentials)
                    .then(
                        // success
                        response => {
                            _passwordResetSent = {
                                'success': true,
                                'message': response.success
                            };
                        },
                        // error
                        response => {
                            _passwordResetSent = {
                                'success': false, 
                                'error': response.data
                            };
                        }
                    );
            };
            
            function resetPasswordSent() { return _passwordResetSent };
        }
    ]);
})(angular);
